export default class BenefitQuotesAbstractServices {
  static getMembersProductsAndModalities(memberNumber) {
    logger.error(`BenefitQuotes:: getMembersProductsAndModalities(${memberNumber}) not implemented`);
  }

  static getMultiStepFormReferenceData() {
    logger.error(`BenefitQuotes:: getMultiStepFormReferenceData() not implemented`);
  }

  static getLandingPageReferenceData() {
    logger.error(`BenefitQuotes:: getLandingPageReferenceData() not implemented`);
  }

  static getProvidersForSelectedModality(modalityCode, providerNumber, providerSurname, suburb, state, postcode) {
    logger.error(`BenefitQuotes:: getProvidersForSelectedModality(${modalityCode}, ${providerNumber}, ${providerSurname}, ${suburb}, ${state}, ${postcode}) not implemented`);
  }

  static getServicesForSelectedModality(modalityCode) {
    logger.error(`BenefitQuotes:: getServicesForSelectedModality(${modalityCode}) not implemented`);
  }

  static submitBenefitQuote(memberNumber, contactID, providerID, providerFlexCode, subProviderIdentifier, subProviderIdentifierType, productCode, services) {
    logger.error(
      `BenefitQuotes:: submitBenefitQuote(${memberNumber}, ${contactID}, ${providerID}, ${providerFlexCode}, ${subProviderIdentifier}, ${subProviderIdentifierType}, ${productCode}, ${services}) not implemented`,
    );
  }

  static getBenefitQuoteDetails(benefitQuoteID) {
    logger.error(`BenefitQuotes:: getBenefitQuoteDetails(${benefitQuoteID}) not implemented`);
  }

  static search() {
    logger.error(`BenefitQuotes:: search() not implemented`);
  }
}
